import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-663fc598"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-text-[red]"
}

import { DROPDOWN_TYPE } from "@/utils/constants";
import MutliLevelMutliSelectDropdown from "../common/mutliLevelMutliSelectDropdown/mutliLevelMutliSelectDropdown.vue";
import { PropType, computed, ref } from "vue";
import { IMultiSelectDropdown } from "@/interfaces/common/IDropDown";
import VRuntimeTemplate from "vue3-runtime-template";


export default /*#__PURE__*/_defineComponent({
  __name: 'wizardMultiLevelMultiSelectQuestion',
  props: {
  modelValue: {
    type: String,
    required: false,
    default: "",
  },
  title: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  answer: {
    type: Number,
    default: null,
  },
  dropdownData: {
    type: Object as PropType<IMultiSelectDropdown[]>,
    default: () => [] as IMultiSelectDropdown[],
  },
  type: {
    type: String,
    required: false,
    default: DROPDOWN_TYPE.MULTIPLE,
  },
  placeholder: {
    type: String,
    required: false,
    default: "",
  },
  searchPlaceholder: {
    type: String,
    required: false,
    default: "",
  },
  validation: {
    type: Object,
    required: false,
    default: null,
  },
  timeUpdated: {
    type: String,
    required: false,
    default: "false",
  },
  notOptional: {
    type: Boolean,
    default: false,
  },
  isApiError: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /** Event on value update */
  "update:modelValue",
  "update:store",
],
  setup(__props, { emit }) {

const props = __props;




const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {},
});

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createBlock(_component_b_row, {
    class: _normalizeClass(`row-container tw-flex tw-flex-row tw-gap-[40px] tw-mr-0 tw-ml-0 tw-flex-wrap tw-justify-between tw-items-center`)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_col, {
        class: _normalizeClass(['tw-pr-0 tw-pl-0 tw-flex tw-item-center'])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(`tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[145%] ${
          __props.required ? 'question' : 'tw-relative'
        }`)
          }, [
            _createElementVNode("span", null, _toDisplayString(__props.title), 1),
            (__props.notOptional)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, " *"))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }),
      _createVNode(_component_b_col, {
        class: _normalizeClass('col-sm-6 tw-pr-0 tw-pl-0')
      }, {
        default: _withCtx(() => [
          _createVNode(MutliLevelMutliSelectDropdown, {
            modelValue: value.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
              _cache[2] || (_cache[2] = 
          (value, data) => {
            emit('update:modelValue', value, data);
          }
        )
            ],
            data: __props.dropdownData || [],
            type: __props.type,
            "time-updated": __props.timeUpdated,
            "enable-search": __props.type === _unref(DROPDOWN_TYPE).MULTIPLE,
            placeholder: __props.placeholder,
            "search-placeholder": __props.searchPlaceholder,
            "main-wrapper-class": `${
          __props.validation?.$errors[0] ? 'is-invalid-input' : ''
        } ${
          __props.isApiError
            ? '!tw-border-[red] tw-border-[1px] tw-border-solid tw-rounded-[6px]'
            : ''
        }`,
            "data-cy-id": "wizard-multi-level-multi-select-question",
            "onUpdate:store": _cache[1] || (_cache[1] = () => emit('update:store'))
          }, null, 8, ["modelValue", "data", "type", "time-updated", "enable-search", "placeholder", "search-placeholder", "main-wrapper-class"]),
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "feedback", {}, () => [
              _createVNode(_component_b_form_invalid_feedback, {
                class: _normalizeClass({ 'is-invalid': __props.validation?.$error })
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(VRuntimeTemplate), {
                    template: __props.validation?.$errors?.[0]?.$message
                  }, null, 8, ["template"])
                ]),
                _: 1
              }, 8, ["class"])
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})